import React, {FC, useState} from "react";
import * as fa from "@fortawesome/free-solid-svg-icons"
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import { Input } from "@traas/lib/src/components/form/Input";
import {useApiService} from "../../../lib/src/api/hooks/useApiService";
import config from "../config";
import {getToken} from "@ventumsoftware/react-toolkit";
import {useNavigate} from "react-router";
import {ErrorBag} from "../api/api";
import {Employee} from "../../../lib/src/api/dto/Employee";
import {Workorder} from "../../../lib/src/api/dto/Workorder";
import {Moment} from "moment";
import {Select} from "../../../lib/src/components/form/Select";
import {useApi} from "../api/APIContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faInfoCircle, faWarning } from "@fortawesome/pro-light-svg-icons";
import {TimeRegistration} from "../../../lib/src/api/dto/TimeRegistration";

export const AddHourEntryModal: FC<{employee: Employee, day: Moment, workorders: Workorder[], timeEntries: TimeRegistration[]}> = (props) => {
  const navigate= useNavigate();
  const {timeRegistrationService} = useApiService(config, getToken, navigate)
  const [workorderId, setWorkorderId] = useState<string>('-')
  const [input, setInput] = useState<number|null>(null)
  const {onHoursUpdated} = useApi()
  const [errors, setErrors] = React.useState<ErrorBag>({})
  const timeWithoutWorkorder = props.timeEntries.find((entry) => entry.workorderId === null)

  const confirm = async () => {
    const hours = input ?? 0
    const isPlaceholder = workorderId === '-'

    if (timeWithoutWorkorder === undefined) {
      // Always make sure a placeholder exists; only give it the hours if the user is saving to the placeholder
      await timeRegistrationService.add(props.employee.id, props.day.toDate(), isPlaceholder ? hours : 0, undefined)
    } else if (isPlaceholder) {
      // Placeholder exists and the user is editing it -> update
      await timeRegistrationService.update(
        timeWithoutWorkorder.id,
        timeWithoutWorkorder.employeeId,
        timeWithoutWorkorder.date,
        hours,
        timeWithoutWorkorder.remark ?? undefined
      )
    }

    // A workorder was chosen -> always a new entry
    if (!isPlaceholder) {
      await timeRegistrationService.add(props.employee.id, props.day.toDate(), hours, workorderId)
    }

    await onHoursUpdated()
  }

  const workorderOptions = Object.fromEntries([
    ['-', 'Geen werkbon'],
    ...props.workorders.map(wo => [wo.workorderId, `${wo.projectDescription} - ${wo.description}`])
  ])

  return <form>
    <div className={"space-y-2"}>
      <div className={'flex flex-row px-2 py-3 my-4 gap-x-4 border border-slate-200 rounded-md'}>
        <div>Geselecteerde werknemer: </div>
        <div className={'font-semibold '}>{props.employee.firstName} {props.employee.lastName}</div>
      </div>

      {!timeWithoutWorkorder && workorderId === '-' && <div className={'flex flex-row px-2 py-3 my-4 gap-x-4 items-center bg-brand-50 text-brand-950 border border-brand-950 rounded-md'}>
        <div><FontAwesomeIcon icon={faInfoCircle}/></div>
        <div className={'text-sm'}>
          Wanneer er geen werkbon geselecteerd staat is het nog steeds mogelijk om een tijd voor deze werknemer te schrijven. Deze tijd staat dan los van een werkbon.
        </div>
      </div>}

      {timeWithoutWorkorder && workorderId === '-' && <div className={'flex flex-row px-2 py-3 my-4 gap-x-4 items-center bg-brand-50 text-brand-950 border border-brand-950 rounded-md'}>
        <div><FontAwesomeIcon icon={faWarning}/></div>
        <div className={'text-sm'}>
          <span className={'font-semibold'}>Let op!</span> <br/>
          Er staat al een tijd zonder werkbon geschreven voor deze werknemer op deze dag. Het toevoegen hiervan overschrijft de bestaande tijd.
        </div>
      </div>}

      <div className={'grid grid-cols-6 gap-4'}>
        <div className={'col-span-5'}>
          <Select label={'Werkbon (optioneel)'} options={workorderOptions} value={workorderId} onChange={setWorkorderId} />
        </div>
        <div className={'col-span-1'}>
          <Input type={'number'} min={-14} max={14} step={0.25} label={'Uren'} value={input ?? 0} onChange={(change) => {
            setInput(change)
          }} />
        </div>
      </div>
      <ModalFooter icon={fa.faSave} text={"Opslaan"} onSubmit={confirm}/>
    </div>
  </form>

}
